import React from 'react';
import { useLocation } from 'react-router';
import { Button, StepsIndicator } from '../../../components/ui';
import './CheckoutComplete.scss';

import cartSlice, { getCart } from '../../../store/slices/cart.slice';
import { useDispatch, useSelector } from 'react-redux';

const CheckoutComplete = () => {
  const dispatch = useDispatch();
  const { orderId } = useSelector(getCart);

  const onCartReset = () => {
    dispatch(cartSlice.actions.resetCart());
  };

  return (
    <div className="template-cart-checkout-success">
      <StepsIndicator count={3} step={3}></StepsIndicator>
      <h1 className="header">ORDER COMPLETE</h1>
      <div className="order-completed-page">
        <h2 className="text heading uppercase black size26">Thank you</h2>
        <p>Your order has been successfully processed!</p>
        <h3>
          <strong>Order number: {orderId}</strong>
        </h3>
        <div className="cta-container checkout">
          <Button path="/eyeglasses" click={onCartReset}>
            Continue
          </Button>
          <Button className="button submit-button" path="/" click={onCartReset}>
            Exit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutComplete;
